import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import CustomerSegmentsManager from './CustomerSegmentsManager';

type Props = {
  open: boolean;
  onClose: () => void;
};

const CustomerSegmentsModal: React.FC<Props> = ({ open, onClose }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-black/50"
        aria-hidden
        onClick={onClose}
      />
      <div
        className="relative bg-white rounded-xl shadow-xl w-full max-w-5xl max-h-[90vh] flex flex-col"
        role="dialog"
        aria-modal="true"
        aria-labelledby="customer-segments-modal-title"
      >
        <div className="flex items-center justify-between shrink-0 px-6 py-4 border-b border-gray-200">
          <h2 id="customer-segments-modal-title" className="text-xl font-semibold text-gray-900">
            Customer Segments
          </h2>
          <button
            type="button"
            onClick={onClose}
            className="p-2 text-gray-400 hover:text-gray-600 rounded-lg hover:bg-gray-100"
            aria-label="Close"
          >
            <XMarkIcon className="h-5 w-5" />
          </button>
        </div>
        <div className="overflow-y-auto flex-1 p-6 min-h-0">
          <CustomerSegmentsManager />
        </div>
      </div>
    </div>
  );
};

export default CustomerSegmentsModal;
